'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = require('lodash');
var TPA_WIDGET_TYPE = 'wysiwyg.viewer.components.tpapps.TPAWidget';

var TypeUtils = function () {
  function TypeUtils(typesData) {
    _classCallCheck(this, TypeUtils);

    this._typesData = typesData;
  }

  _createClass(TypeUtils, [{
    key: 'getSdkType',
    value: function getSdkType(viewerType, tpaWidgetId) {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;
      var defaultSdkType = typesData.defaultSdkType;

      if (tpaWidgetId && viewerType !== TPA_WIDGET_TYPE) {
        throw new Error('tpaWidgetId is only supported with viewer type [' + TPA_WIDGET_TYPE + ']');
      }

      return sdkTypeByWidgetId[tpaWidgetId] || sdkTypeByViewerType[viewerType] || defaultSdkType;
    }
  }, {
    key: 'getFullSdkType',
    value: function getFullSdkType(viewerType, tpaWidgetId) {
      return '$w.' + this.getSdkType(viewerType, tpaWidgetId);
    }
  }, {
    key: 'getPotentialViewerTypes',
    value: function getPotentialViewerTypes(sdkType) {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

      var types = _.keys(sdkTypeByViewerType);
      var resultViewerTypes = types.filter(function (viewerType) {
        return sdkTypeByViewerType[viewerType] === sdkType;
      });
      var isPotentiallyTPA = _.includes(_.values(sdkTypeByWidgetId), sdkType);
      if (isPotentiallyTPA) {
        resultViewerTypes.push('wysiwyg.viewer.components.tpapps.TPAWidget');
      }
      return resultViewerTypes;
    }
  }, {
    key: 'Types',
    get: function get() {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

      var allSdkTypes = _.uniq(_.values(sdkTypeByViewerType).concat(_.values(sdkTypeByWidgetId)));
      return _.zipObject(allSdkTypes, allSdkTypes);
    }
  }, {
    key: 'defaultSdkType',
    get: function get() {
      var typesData = this._typesData;
      return typesData.defaultSdkType;
    }
  }]);

  return TypeUtils;
}();

module.exports = TypeUtils;


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/typeUtils/typeUtils.js